import posed from "react-pose"

export default posed.div({
  enter: { opacity: 1 },
  exit: { opacity: 0 }
})
